import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { CourseEnrollment } from '../enrollments-view.part';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService): GridSetup<CourseEnrollment> {

	return {
		rowName: { singular: 'Enrollment', plural: 'Enrollments' },
		getRowKey: row => '' + row.courseEnrollmentId,
		stateKey: 'accelerator-enrollments-grid',
		actions: getActions(),
		buttons: [],
		columns: getColumns(util),
	}
}
